/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IdeaCommentDtoListResult } from '../models/IdeaCommentDtoListResult';
import type { IdeaDto } from '../models/IdeaDto';
import type { IdeaDtoListResult } from '../models/IdeaDtoListResult';
import type { IdeaInput } from '../models/IdeaInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ForumService {

    /**
     * @param version 
     * @param offset 
     * @returns IdeaDtoListResult OK
     * @throws ApiError
     */
    public static listPublicIdeas(
version: string,
offset?: number,
): CancelablePromise<IdeaDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Forum/Public',
            path: {
                'version': version,
            },
            query: {
                'offset': offset,
            },
        });
    }

    /**
     * @param version 
     * @param offset 
     * @returns IdeaDtoListResult OK
     * @throws ApiError
     */
    public static listPrivateIdeas(
version: string,
offset?: number,
): CancelablePromise<IdeaDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Forum/Private',
            path: {
                'version': version,
            },
            query: {
                'offset': offset,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns IdeaDto OK
     * @throws ApiError
     */
    public static createIdea(
version: string,
requestBody?: IdeaInput,
): CancelablePromise<IdeaDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Forum',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param ideaId 
     * @param version 
     * @param requestBody 
     * @returns IdeaDto OK
     * @throws ApiError
     */
    public static updateIdea(
ideaId: number,
version: string,
requestBody?: IdeaInput,
): CancelablePromise<IdeaDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/v{version}/Forum/{ideaId}',
            path: {
                'ideaId': ideaId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param ideaId 
     * @param version 
     * @param offset 
     * @returns IdeaCommentDtoListResult OK
     * @throws ApiError
     */
    public static listIdeaComments(
ideaId: number,
version: string,
offset?: number,
): CancelablePromise<IdeaCommentDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Forum/{ideaId}/Comment',
            path: {
                'ideaId': ideaId,
                'version': version,
            },
            query: {
                'offset': offset,
            },
        });
    }

    /**
     * @param ideaId 
     * @param version 
     * @returns number OK
     * @throws ApiError
     */
    public static toggleLike(
ideaId: number,
version: string,
): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/v{version}/Forum/{ideaId}/Like/Toggle',
            path: {
                'ideaId': ideaId,
                'version': version,
            },
        });
    }

}
